import React from 'react';
import i18next from 'i18next';
import { DateFormatter, TextCell } from 'components/AppTable/CellsComponents';

const getTableConfig = () => {
  return [
    {
      field: 'userId',
      title: 'User ID',
      isVisible: false,
    },
    {
      title: i18next.t('tablesLabels.studentId'),
      field: 'ids',
      Component: value => value || i18next.t('courseDetails.notSpecified'),
      isSorting: true,
    },
    {
      title: i18next.t('tablesLabels.name'),
      field: 'fullName',
      Component: value => <TextCell value={value} />,
      isSorting: true,
    },
    {
      title: i18next.t('tablesLabels.trainingModule'),
      field: 'trainingModuleName',
      Component: value => <TextCell value={value} />,
      isSorting: true,
    },
    {
      title: i18next.t('tablesLabels.trainingPart'),
      field: 'trainingMethod',
      Component: value => (
        <TextCell
          value={value ? i18next.t(`trainingModules.tabs.${value}`) : i18next.t('courseDetails.notSpecified')}
        />
      ),
      isSorting: true,
    },
    {
      title: i18next.t('complianceStatus'),
      field: 'complianceStatus',
      Component: value => (
        <TextCell
          value={
            value
              ? i18next.t(`compliance.statuses.${value}`, { defaultValue: value })
              : i18next.t('compliance.statuses.incomplete')
          }
        />
      ),
      isSorting: true,
    },
    {
      title: i18next.t('tablesLabels.performedDate'),
      field: 'performationDate',
      Component: value => (value === null ? i18next.t('courseDetails.incomplete') : <DateFormatter value={value} />),
      isSorting: true,
    },
    {
      title: i18next.t('tablesLabels.expiryDate'),
      field: 'expirationDate',
      Component: value => (value ? <DateFormatter value={value} /> : i18next.t('compliance.statuses.incomplete')),
      isSorting: true,
    },
  ];
};

export default getTableConfig;
